import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    add: 'Create an invoice',
    presets: 'Invoicing settings',
    searchbar: 'Search by invoice number or title, client...',
    statuses: {
      canceled: 'Canceled',
      'not-sent': 'Draft',
      overdue: 'Overdue',
      paid: 'Paid',
      sent: 'Sent',
    },
    title: 'Invoices',
  },
  fr: {
    add: 'Créer une facture',
    presets: 'Paramètres de facturation',
    searchbar: 'Recherche par numéro ou titre de facture, client·e...',
    statuses: {
      canceled: 'Annulées',
      'not-sent': 'Brouillon',
      overdue: 'En retard',
      paid: 'Payées',
      sent: 'Envoyées',
    },
    title: 'Factures',
  },
} as const);

export default locales;
